import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ExerciseExplaination from "../components/ExerciseExplaination";
import { exerciseOptions, fetchData } from "../utils/fetchData";
import Loader from "../components/Loader";

export default function ExerciseDetails() {
  const [exerciseData, setExerciseData] = useState([]);
  const [exerciseDetail, setExerciseDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { workout } = useParams();

  const fetchExerciseData = async () => {
    try {
      setIsLoading(true);
      const data = await fetchData(
        "https://work-out-api1.p.rapidapi.com/search",
        exerciseOptions
      );
      setExerciseData(data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchExerciseData();
  }, []);

  useEffect(() => {
    const output = exerciseData.filter((exercise) => {
      return exercise.WorkOut.includes(workout);
    });
    setExerciseDetail(output);
  }, [workout, exerciseData]);

  return (
    <section className="mt-16">
      {isLoading ? (
        <Loader />
      ) : (
        exerciseDetail.map((eachData, index) => (
          <ExerciseExplaination result={eachData} key={index} />
        ))
      )}
    </section>
  );
}

{
  /* // <ExerciseExplaination result={exerciseDetail} /> */
}
